import './HArticleContentList.scss';

import * as tsx from 'vue-tsx-support';
import { PropType, VNode } from 'vue';
import { HText } from '../HText';
import { HHeading } from '../HHeading';
import { HMedia } from '../HMedia';
import { HTableOfContents, TableOfContentsItem } from '../HTableOfContents';
import { ResolvedLanugageData } from '~/server-middleware/data-server/adapter/ACCOAdapter/schemes';
import {
  AvailableLanguage,
  ArticleContentListModule,
  NAVIGATION_PREFIX,
} from '~/schemes';

export const ArticleContentList = tsx.component({
  name: 'ArticleContentList',
  functional: true,

  props: {
    value: {
      type: Object as PropType<
        ResolvedLanugageData<
          ArticleContentListModule['properties'],
          AvailableLanguage
        >
      >,
      required: true,
    },

    /**
     * コンテナクラスの付与を無効にする場合に指定する
     */
    disableContainer: Boolean,
  },

  render(h, { props, data }): VNode {
    const { showToc, showSectionLine, children } = props.value;

    const getHeadingText = (child: typeof children[0]): string => {
      const body = child.properties.heading.properties.body;
      return body && body.text ? body.text : '';
    };

    const tocItems: TableOfContentsItem[] = children
      .map((child, index) => ({
        id: `${NAVIGATION_PREFIX}${index + 1}`,
        text: getHeadingText(child),
      }))
      .filter((item) => item.text !== '');

    return (
      <div staticClass="h-article-content-list-module">
        {showToc && !!tocItems.length && <HTableOfContents items={tocItems} />}

        {children.map((child, index) => {
          return (
            <div
              staticClass="h-article-content-list-module__article-content"
              class={{
                'h-article-content-list-module__article-content--with-border': showSectionLine,
              }}
              id={`${NAVIGATION_PREFIX}${index + 1}`}>
              <HHeading value={child.properties.heading.properties} />
              {child.properties.mediaWithTextList.map((mediaWithText) => (
                <div staticClass="h-article-content-list-module__media-with-text">
                  <HMedia value={mediaWithText.properties.media.properties} />
                  <HText value={mediaWithText.properties.text.properties} />
                </div>
              ))}
            </div>
          );
        })}
      </div>
    );
  },
});
